<template>
  <div class="setting-addel widget-select-toggle">
    <span class="dashboard-icon-group">
      <el-tooltip content="기본편집모드" placement="top">
        <el-button class="btn-select" size="mini" :style="toggleStyle(DashboardConst.EDIT_SELECT_MODE.SELECTION)" @click="selectMode = DashboardConst.EDIT_SELECT_MODE.SELECTION"></el-button>
        <!-- <el-button class="btn-select" size="mini" :style="toggleStyle(DashboardConst.EDIT_SELECT_MODE.SELECTION)" @click="selectMode = DashboardConst.EDIT_SELECT_MODE.SELECTION"><i class="fas fa-vector-square" style="font-size:14px;"></i></el-button> -->
      </el-tooltip>
      <el-tooltip content="이동모드" placement="top">
        <el-button class="btn-move" size="mini" :style="toggleStyle(DashboardConst.EDIT_SELECT_MODE.MOVE)" @click="selectMode = DashboardConst.EDIT_SELECT_MODE.MOVE"></el-button>
        <!-- <el-button class="btn-move" size="mini" :style="toggleStyle(DashboardConst.EDIT_SELECT_MODE.MOVE)" @click="selectMode = DashboardConst.EDIT_SELECT_MODE.MOVE"><i class="fas fa-mouse-pointer" style="font-size:14px;"></i></el-button> -->
      </el-tooltip>
    </span>
  </div>
</template>

<script>
import DashboardConst from '@/constants/dashboard';

export default {
  name: 'WWidgetSelectToggle',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DashboardConst,
    };
  },
  computed: {
    selectMode: {
      get() {
        return this.$store.getters.getEditSelectMode;
      },
      set(value) {
        return this.$store.commit('setEditSelectMode', value);
      },
    },
    toggleStyle() {
      return (mode) => {
        if (this.selectMode === mode) {
          return {
            'background-color': '#f1f2f5',
          };
        }
        return null;
      };
    },
  },
  methods: {},
};
</script>

<style lang="scss">
.widget-select-toggle {
  display: inline-block;

  .el-button {
    height: 30px;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/WidgetSelectToggle.vue